import slugify from "slugify";

/**
 * Build a filesystem-safe PNG name from a chart title and optional filter context
 * (e.g. reporting year).
 */
export function chartDownloadFilename(title, context = "") {
  const base = slugify(String(title || "chart"), {
    lower: true,
    strict: true,
  });
  const suffix = context
    ? slugify(String(context), { lower: true, strict: true })
    : "";
  return suffix ? `${base}-${suffix}.png` : `${base}.png`;
}
